import { render, staticRenderFns } from "./Form612_v2.vue?vue&type=template&id=0a05eadc&scoped=true&"
import script from "./Form612_v2.vue?vue&type=script&lang=js&"
export * from "./Form612_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form612_v2.vue?vue&type=style&index=0&id=0a05eadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05eadc",
  null
  
)

export default component.exports